import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import CustomPerksDashboard from '../../../PerksHub/CustomPerksDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCustomPerks } from './companyPerksApi';

/**
 * Company Perks → Custom Perks. Analytics only; creating and editing perks
 * stays on the existing /:slug/offering page, which "Manage perks" links to.
 */
const CPerksCustom = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    () => fetchCustomPerks(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Custom Perks | Shoorah</title>
      </Helmet>
      <CustomPerksDashboard
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
        onManagePerks={() => navigate(`/${slug}/offering`)}
      />
    </div>
  );
};

export default CPerksCustom;
